import React from "react";
import { Capacitor } from "@capacitor/core";

// For bars that sit on top of the keyboard (Planner quick add, Clock-In note bar).
// On Android the viewport already ends at the keyboard's top edge (SystemBars
// insetsHandling "css" pads it), so bottom: 0 sits on the keyboard and this
// returns 0. In a phone browser the keyboard overlays the page instead, so this
// is the visualViewport gap to lift by.
const isNative = Capacitor.isNativePlatform();

export function useBrowserKeyboardInset() {
  const [inset, setInset] = React.useState(0);
  React.useEffect(() => {
    if (isNative) return;
    const vv = window.visualViewport;
    if (!vv) return;
    const onChange = () => setInset(Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)));
    vv.addEventListener("resize", onChange);
    vv.addEventListener("scroll", onChange);
    onChange();
    return () => { vv.removeEventListener("resize", onChange); vv.removeEventListener("scroll", onChange); };
  }, []);
  return inset;
}
